import { type ReactNode } from 'react';
import styles from './TagChipRow.module.css';

interface TagChipRowProps {
  children: ReactNode;
  /** Optional extra classes (e.g. outer padding from a parent feature). */
  className?: string;
}

/**
 * Flex-wrap row layout shared by `TagsPanel` (editor) and `TagsSection`
 * (read-only viewer). Owns spacing between chips so the two surfaces stay
 * visually consistent; outer padding is the parent's responsibility.
 */
export default function TagChipRow({ children, className }: TagChipRowProps) {
  const cls = className ? `${styles.row} ${className}` : styles.row;
  return (
    <div className={cls} role="list">
      {children}
    </div>
  );
}
